import configureStore, {history} from './store';

export {history};

export default configureStore;
